import ReactQuill from "react-quill"
import 'react-quill/dist/quill.snow.css'

export default function TextEditor({value, onChange, height}) {




    return (
            <ReactQuill
                theme='snow'
                value={value ||''}
                onChange={onChange}
                className="text-editor"
            />
    )
}

